var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyciemopemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.3 50.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "29.34 29.34 33.53 50.3 46.1 50.3 50.3 29.34 29.34 29.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.05 46.1 23.05 41.91 16.77 41.91 16.77 0 12.57 0 12.57 41.91 6.29 41.91 6.29 46.1 0 46.1 0 50.3 29.34 50.3 29.34 46.1 23.05 46.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.82,14.67c-5.79,0-10.48,4.69-10.48,10.48h4.19c0-3.47,2.81-6.29,6.29-6.29s6.29,2.82,6.29,6.29h4.19c0-5.79-4.69-10.48-10.48-10.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyciemopemIcon);
export default __webpack_public_path__ + "static/media/Mycie mopem_icon.40bc2e0345515ce55cc249ef3422da82.svg";
export { ForwardRef as ReactComponent };